import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import ModalApp from "../../../../components/ModalApp";

const AereoTermsModal = ({ show, handleModal }) => {
  return (
    <ModalApp show={show} handleModal={handleModal}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxHeight: "70vh",
        }}
      >
        <h5
          className="text-center font-wl-600"
          style={{
            padding: "0 16px 16px 16px",
            margin: 0,
            borderBottom: "1px solid #eee",
            flexShrink: 0,
          }}
        >
          TERMOS E CONDIÇÕES GERAIS DE USO - PASSAGENS AÉREAS
        </h5>
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "16px",
            textAlign: "left",
          }}
        >
          <h5
            className="text-center font-wl-600"
            style={{
              padding: "0 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            1. TRANSPORTE AÉREO
          </h5>
          <p className="text-sm mb-3">
            <strong>1.1</strong> O bilhete de passagem aérea é a expressão do
            Termo e Condições de Uso de Transporte Aéreo, firmado entre o
            Cliente e a empresa de transporte, sendo, portanto, regido pela
            Agência Nacional de Aviação Civil (ANAC) através da Resolução nº
            400, de 13/12/2016.
          </p>
          <p className="text-sm mb-3">
            <strong>1.2</strong> Após o resgate, o envio das informações
            relativas ao serviço e a emissão do bilhete/confirmação de resgate
            se dará por meio do e-mail informado pelo participante em seu
            cadastro no programa, sendo de sua exclusiva responsabilidade a
            veracidade das informações fornecidas. O programa não se
            responsabiliza pelo não recebimento do e-mail pelo participante.
            Caso o participante não venha a receber o e-mail com a informação
            de seu resgate/voucher no prazo de até 6 (seis) horas contadas do
            resgate, deverá entrar em contato com a Central de Atendimento do
            Programa.
          </p>
          <p className="text-sm mb-3">
            <strong>1.3</strong> O Cliente deverá preencher todos os campos com
            dados exatos para poder realizar reservas válidas e se
            responsabiliza pela veracidade, exatidão, vigência e autenticidade
            dos dados inseridos. Os dados deverão coincidir de forma exata com
            a documentação de viagem destacada nos itens “13” e “18” e
            subitens. O Programa não se responsabiliza por eventuais erros de
            digitação do Cliente.
          </p>
          <p className="text-sm mb-3">
            <strong>1.4</strong> Não será permitido a correção ou alteração no
            nome dos passageiros após a emissão do bilhete e envio do voucher.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            2. CHECK-IN E EMBARQUE
          </h5>
          <p className="text-sm mb-3">
            <strong>2.</strong> O Cliente deverá apresentar-se no aeroporto para
            o check-in junto à companhia aérea no mínimo 02 (duas) horas antes
            do horário previsto para embarque em voo nacional e no mínimo 03
            (três) horas antes do horário previsto para embarque em voo
            internacional, sendo de sua responsabilidade, inclusive, a
            confirmação do voo junto à companhia aérea com 72 (setenta e duas)
            horas de antecedência do horário de partida.
          </p>
          <p className="text-sm mb-3">
            <strong>2.1</strong> Em caso de atraso, cancelamento do voo ou
            overbooking, será aplicada a política e o procedimento de
            reembolso da respectiva companhia aérea.
          </p>
          <p className="text-sm mb-3">
            <strong>2.1.1</strong> Em casos de ameaça confirmada de ocorrência
            de fenômenos da natureza, situação de calamidade pública,
            perturbação da ordem, acidentes ou greves prejudiciais aos serviços
            de viagem e que, eventualmente não permitam ao Cliente a
            continuidade de sua viagem, alterações de horário e cancelamentos
            total ou parcial do serviço, os valores já cobrados, quando
            cabível, estão sujeitos às políticas de reembolso aplicadas pelas
            companhias aéreas, não cabendo ao Programa qualquer responsabilidade
            por tais imprevistos.
          </p>
          <p className="text-sm mb-3">
            <strong>2.1.2</strong> Na hipótese de cisão, cessão, fusão,
            incorporação, recuperação judicial ou falência decretada pelas cias
            aéreas, as mesmas serão as únicas e exclusivas responsáveis pelas
            perdas e danos eventualmente causados aos clientes, decorrentes de
            sua troca de pontos por passagens aéreas.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            3. RESPONSABILIDADE POR BAGAGEM E ACIDENTES
          </h5>
          <p className="text-sm mb-3">
            <strong>3.</strong> Em caso de acidentes pessoais, danificação,
            perda ou extravio de bagagem, fica o Cliente desde já ciente que a
            responsabilidade por eventuais prejuízos suportados, de qualquer
            natureza, será exclusiva da companhia aérea em questão, nada podendo
            reclamar ou requerer junto ao Programa.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            4. ESCALAS E CONEXÕES
          </h5>
          <p className="text-sm mb-3">
            <strong>4.</strong> A realização de escalas ou paradas técnicas
            ficará a critério do comandante da aeronave e/ou da companhia aérea,
            a qual não poderá retardar um voo para aguardar Clientes retidos por
            autoridades fiscais ou policiais para fiscalização, caso em que
            ficará caracterizado o não embarque, não podendo o Cliente cobrar do
            Programa qualquer tipo de reembolso ou ressarcimento,
            independentemente do motivo que o originou.
          </p>
          <p className="text-sm mb-3">
            <strong>4.1</strong> Para voos com conexão, o Cliente deve estar
            ciente da necessidade de considerar um intervalo mínimo entre os
            voos, previsto nas normas internacionais, não podendo o Programa ser
            responsabilizado em caso de impossibilidade de embarque em
            decorrência do encerramento do check-in ou partida da aeronave.
          </p>
          <p className="text-sm mb-3">
            <strong>4.2</strong> Nos casos de voos com conexão em aeroportos
            diferentes, o transporte entre eles ficará a cargo do passageiro.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            5. OPERAÇÃO DOS VOOS E ASSENTOS
          </h5>
          <p className="text-sm mb-3">
            <strong>5.</strong> Os voos podem ser operados por aeronaves da
            companhia aérea escolhida pelo cliente ou de companhias aéreas
            parceiras destas. Esta decisão será sempre da companhia aérea, sem
            qualquer ingerência por parte do Programa.
          </p>
          <p className="text-sm mb-3">
            <strong>5.1</strong> As marcações antecipadas de assentos nas
            aeronaves estão sujeitas a disponibilidade da cia aérea, a qual
            poderá cobrar para execução do serviço, não tendo o Programa
            qualquer ingerência sobre tais valores e procedimento, que deverá
            ser solicitado pelo Cliente diretamente à cia aérea contratada.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            6. BAGAGENS
          </h5>
          <p className="text-sm mb-3">
            <strong>6.</strong> As companhias aéreas poderão cobrar pelo
            despacho de qualquer bagagem, independente do peso ou destino, com
            direito à 01 bagagem de mão de no máximo 10 Kg. As regras sobre o
            despacho de bagagens, valores e cobranças são de inteira
            responsabilidade das companhias aéreas e devem ser observadas pelos
            passageiros no ato da compra e diretamente com a companhia aérea
            contratada, nada podendo reclamar ou requerer posteriormente junto
            ao Programa.
          </p>
          <p className="text-sm mb-3">
            <strong>6.1</strong> O transporte de bagagem será feito de acordo
            com os critérios da companhia aérea escolhida, cujo limite de peso
            poderá variar de acordo com o trecho e a companhia aérea que operará
            o transporte. O Cliente fica ciente que, quando da realização de
            viagens internacionais, existem restrições quanto ao transporte de
            líquidos, sendo certo que o volume total máximo permitido será
            sempre 100ml.
          </p>
          <p className="text-sm mb-3">
            <strong>6.2</strong> O Cliente deverá verificar as condições de sua
            bagagem no momento do desembarque e, se necessário, reclamar
            imediatamente no balcão da empresa aérea. Não há exceções à regra
            por parte destas.
          </p>
          <p className="text-sm mb-3">
            <strong>6.3</strong> A bagagem de mão e objetos pessoais são de
            responsabilidade exclusiva do Cliente, o qual deverá zelar por sua
            guarda, não podendo o Programa ser responsabilizado por eventual
            furto ou extravio de seus pertences.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            7. DOCUMENTAÇÃO E VISTOS
          </h5>
          <p className="text-sm mb-3">
            <strong>7.</strong> Cabe ao Cliente verificar junto aos Consulados
            dos países que pretendem visitar, bem como países em que fará
            conexões ou escalas, a necessidade de obtenção de vistos ou
            autorizações especiais para ingresso e/ou deslocamento no país, bem
            como seguro de viagem obrigatório, quando a viagem tiver como
            destino ou conexão países da Europa (determinação feita pelos países
            europeus a partir do Tratado de Schengen), não podendo o Programa
            ser responsabilizado por eventuais impossibilidades ou dificuldades
            de ingresso ou trânsito.
          </p>
          <p className="text-sm mb-3">
            <strong>7.1</strong> A impossibilidade de embarque gerada por falta
            de documentação, documentação incorreta ou ausência de vistos
            específicos caracterizará cancelamento da viagem, sendo aplicadas as
            penalidades relativas a esse procedimento.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            8. DOCUMENTOS PARA EMBARQUE INTERNACIONAL
          </h5>
          <p className="text-sm mb-3">
            <strong>8.</strong> Documentos Classistas, fotocópias ou certidões de
            nascimento não serão aceitos para embarque internacional.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            9. MENORES DE IDADE
          </h5>
          <p className="text-sm mb-3">
            <strong>9.</strong> É de responsabilidade do Cliente verificar quais
            os documentos necessários para embarque de crianças de colo e
            menores de idade, caso necessário.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            10. FUSO HORÁRIO E HORÁRIO DE VERÃO
          </h5>
          <p className="text-sm mb-3">
            <strong>10.</strong> É de responsabilidade do Cliente verificar o
            fuso horário do destino, bem como a existência de horário de verão.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            11. SAÚDE E VACINAÇÃO
          </h5>
          <p className="text-sm mb-3">
            <strong>11.</strong> Cabe ao Cliente informar-se e vacinar-se de
            acordo com a legislação brasileira e do local de destino.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            12. VALORES E PAGAMENTOS
          </h5>
          <p className="text-sm mb-3">
            <strong>12.</strong> Os valores praticados pelo Programa não têm
            qualquer relação com os praticados pelos fornecedores diretamente
            com o mercado consumidor. Assim, diferenças de valores, maiores ou
            menores, entre a tarifa praticada pelo Programa e as tarifas balcão
            ou facial, não serão reembolsadas ou cobradas.
          </p>
          <p className="text-sm mb-3">
            <strong>12.1</strong> Os valores finais informados quando do
            fechamento da compra serão garantidos somente após o pagamento
            integral (pontos e/ou pontos mais cartão de crédito), a aprovação do
            pagamento pela administradora do cartão de crédito utilizado na
            compra, a confirmação da disponibilidade pelas companhias aéreas,
            emissão e envio do voucher (bilhete eletrônico).
          </p>
          <p className="text-sm mb-3">
            <strong>12.2</strong> Os valores estão sujeitos à alteração, podendo
            variar caso o pagamento seja postergado (não fechamento do pedido)
            ou efetuado após o vencimento do prazo de validade da reserva,
            cabendo ao Cliente a confirmação de seu valor quando do pagamento
            efetivo.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            13. VIAGENS NACIONAIS
          </h5>
          <p className="text-sm mb-3">
            <strong>13.1</strong> Para a ANAC (Agência Nacional de Aviação
            Civil), qualquer pessoa a partir de 12 (doze) anos é considerada
            adulta.
          </p>
          <p className="text-sm mb-3">
            <strong>13.2</strong> Para o embarque dentro do Brasil, o Cliente
            adulto precisará de um documento com foto expedido por órgão
            oficial, como por exemplo: Carteira de Identidade (RG original)
            expedida por Secretaria de Segurança Pública de um dos estados da
            Federação ou do Distrito Federal; Carteira Nacional de Habilitação
            (CNH original válida); Passaporte (original e válido) ou; Carteira
            de Conselhos de Classes (CRM, CREA, OAB); Carteira de Identidade
            expedida por órgão subordinado à Presidência da República, incluindo
            o Ministério da Defesa e os Comandos da Aeronáutica, Marinha e
            Exército; Cartão de identidade expedido pelo Poder Judiciário ou
            Legislativo, em nível federal ou estadual; Carteira de Trabalho;
            Licença de piloto, comissário, mecânico de voo e despachante
            operacional de voo emitida pela Agência Nacional de Aviação Civil
            (ANAC); ou Registro Nacional de Estrangeiros (RNE).
          </p>
          <p className="text-sm mb-3">
            <strong>13.3</strong> Para o embarque dentro do Brasil, menores de
            12 (doze) anos poderão embarcar com a Certidão de Nascimento
            original expedido por órgão oficial.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            14. VIAGEM DE MENORES DESACOMPANHADOS
          </h5>
          <p className="text-sm mb-3">
            <strong>14.</strong> Nenhuma criança ou adolescente menor de 16
            (dezesseis) anos poderá viajar para fora da comarca onde reside
            desacompanhado dos pais ou dos responsáveis sem expressa autorização
            judicial, conforme Lei nº 13.812, de 2019.
          </p>
          <p className="text-sm mb-3">
            <strong>15.</strong> Além da documentação necessária, para crianças
            entre 5 (cinco) e 12 (doze) anos incompletos se faz obrigatória a
            contratação do serviço de menor desacompanhado disponibilizado pela
            Agência Nacional de Aviação Civil (ANAC). O serviço é oferecido
            diretamente junto a cia aérea emissora do bilhete e está sujeito a
            cobrança de taxas e encargos extras. O Cliente deverá verificar
            diretamente com a cia aérea todos os valores e condições do serviço.
          </p>
          <p className="text-sm mb-3">
            <strong>16.</strong> Para menores de 16 (dezesseis) anos acompanhado
            por um parente de 1º grau (pai, mãe, irmão, avô ou tios): não haverá
            necessidade de autorização. Em todos os casos em que o menor de 16
            (dezesseis) anos estiver acompanhado de alguém, essa pessoa deverá
            ser maior de 18 (dezoito) anos.
          </p>
          <p className="text-sm mb-3">
            <strong>17.</strong> Toda documentação a ser apresentada no momento
            do embarque deve ser original. Não serão autorizados embarques com
            fotocópias de documentos.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            18. VIAGENS INTERNACIONAIS - DOCUMENTOS
          </h5>
          <p className="text-sm mb-3">
            <strong>18.1</strong> Para o embarque será obrigatória a
            apresentação do passaporte válido.
          </p>
          <p className="text-sm mb-3">
            <strong>18.1.1</strong> Certifique-se da validade do passaporte.
            Ainda que dentro da validade, a validade mínima exigida do
            passaporte varia de acordo com o país a ser visitado, cabendo ao
            Cliente certificar-se quanto a este prazo e não podendo o Programa
            ser responsabilizado caso seu embarque ou trânsito no país de
            destino sejam impossibilitados em razão de irregularidades com o
            passaporte.
          </p>
          <p className="text-sm mb-3">
            <strong>18.2</strong> Para viagens com destino a Argentina, Bolívia,
            Chile, Colômbia, Paraguai, Peru e Uruguai, cidadãos brasileiros
            poderão embarcar apresentando somente carteira de identidade (RG)
            original e em perfeito estado de conservação, emitida há, no máximo
            10 (dez) anos (inclusive menores), ou o passaporte com validade
            acima de 01 (um) ano a considerar da data de retorno ao país de
            origem. Os demais documentos não são aceitos.
          </p>
          <p className="text-sm mb-3">
            <strong>18.3</strong> Alguns países exigem o Certificado
            Internacional de Febre Amarela no momento do embarque. O certificado
            pode ser obtido nos Postos da ANVISA. O Cliente deverá tomar a
            vacina com no mínimo 10 (dez) dias de antecedência do embarque.
            Assim como a vacina, o certificado é válido por 10 (dez) anos.
          </p>
          <p className="text-sm mb-3">
            <strong>18.3.1</strong> Caso o Cliente já tenha tomado a vacina, o
            mesmo deverá apresentar sua carteira de vacinação em algum posto da
            ANVISA para emissão do Certificado Internacional. Não é recomendável
            que o Cliente tome uma nova dose da vacina caso a anterior não tenha
            completado 10 (dez) anos de aplicação.
          </p>
          <p className="text-sm mb-3">
            <strong>19.</strong> Toda documentação a ser apresentada no momento
            do embarque deve ser original. Não serão autorizados embarques com
            fotocópias de documentos.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            20. CANCELAMENTO E ALTERAÇÃO
          </h5>
          <p className="text-sm mb-3">
            <strong>20.1</strong> O usuário poderá desistir da passagem aérea
            adquirida, sem qualquer ônus, desde que o faça no prazo de até 24
            (vinte e quatro) horas, a contar do recebimento do seu comprovante,
            válido somente para as compras feitas com antecedência igual ou
            superior a 7 (sete) dias em relação à data de embarque (Art. 11,
            Resolução ANAC Nº 400 de 13/12/2016).
          </p>
          <p className="text-sm mb-3">
            <strong>20.2</strong> Após a confirmação da troca de pontos, com
            exceção do disposto no item 20.3, em nenhuma outra hipótese será
            admitido o cancelamento desta solicitação e os pontos trocados não
            serão restituídos, assim como o complemento no cartão de crédito.
            Além disso, o valor pago pelo Cliente referente as taxas de embarque
            não é reembolsável após a conclusão da troca de pontos.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4</strong> Somente serão aceitas solicitações de
            cancelamento ou alteração de pedidos já emitidos mediante
            comprovação efetiva de problema de saúde de natureza
            infectocontagiosa ou falecimento do passageiro, com a devida
            apresentação de laudo, ou obrigações judiciais que impeçam o cliente
            de embarcar, ocasiões estas em que serão devidos pelo Cliente
            valores cobrados a título de multas, conforme regras das cias
            aéreas, condição tarifária do bilhete adquirido e política própria
            dos fornecedores.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.1</strong> As penalidades e/ou taxas praticadas pelas
            companhias aéreas e demais fornecedores para cancelamento ou
            alteração dos serviços/produtos turísticos serão informados ao
            Cliente após do pedido de cancelamento ou alteração e todos estão
            sujeitos à essa cobrança.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.2</strong> As penalidades e/ou taxas praticadas pelas
            companhias aéreas são de total responsabilidade destas, sem qualquer
            ingerência por parte do Programa.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.3</strong> Os fornecedores não são obrigados a realizar
            exceções das condições do contrato aos passageiros, mesmo nos casos
            comprovados de doença ou incapacidade física que lhes impeça de
            viajar. Ou seja, se a tarifa ofertada previr a cobrança de
            penalidade para realizar alterações/devoluções ou não permitir
            alterações e/ou devoluções, o fornecedor poderá cobrar esses valores
            ou negar a devolução do custo da reserva.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.4</strong> As alterações ou cancelamentos relacionados
            com serviços/produtos turísticos adquiridos para períodos de férias
            escolares, feriados ou festivos, tais como carnaval, réveillon,
            dentre outros, poderão implicar na perda, pelo Cliente, de até 100%
            (cem por cento) do valor daqueles, dependendo do seu tipo e/ou dos
            procedimentos e das políticas operacionais (penalidades/taxas)
            aplicadas pelos fornecedores.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.5</strong> O Cliente, desde já, fica cientificado que a
            soma das deduções constantes nos itens “20.3.2” e “20.3.3” poderão
            corresponder à perda de até 100% (cem por cento) do valor pago pelos
            serviços/produtos turísticos adquiridos, dependendo do tipo destes
            e/ou dos procedimentos e das políticas operacionais aplicadas pelas
            companhias aéreas, hospedagens e demais fornecedores.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.6</strong> Quando aplicável, o reembolso será pago ao
            cliente solicitante com base no câmbio do dia da compra, na mesma
            forma de pagamento.
          </p>
          <p className="text-sm mb-3">
            <strong>20.4.7</strong> Os prazos de reembolso e/ou do estorno de
            valores dependerão de cada fornecedor. Nos casos das companhias
            aéreas estima-se habitualmente de 30 a 120 dias.
          </p>
          <p className="text-sm mb-3">
            <strong>20.5.</strong> Não são permitidos cancelamentos, alterações
            ou reembolsos após a utilização parcial do produto, seja da parte
            aérea, hospedagem ou qualquer outro serviço.
          </p>
          <p className="text-sm mb-3">
            <strong>20.6.</strong> Não é permitido o cancelamento parcial de
            serviços ou desmembramento dos mesmos.
          </p>
          <p className="text-sm mb-3">
            <strong>20.6.1.</strong> Caso o cliente não utilize os serviços,
            inclusive o bilhete emitido na data e horários escolhidos, este
            perderá sua validade e a pontuação, bem como o complemento no cartão
            de crédito, não serão estornados.
          </p>
          <p className="text-sm mb-3">
            <strong>20.7.</strong> Todas as solicitações de alteração nas
            reservas originais, sejam essas de qualquer tipo, estão sujeitas a
            alterações de valores e disponibilidade de lugares até a confirmação
            efetiva da operação e envio de um novo voucher.
          </p>
          <p className="text-sm mb-3">
            <strong>20.7.1</strong> Além das penalidades aplicáveis, poderá
            existir uma diferença de tarifa que consiste em um valor que resulta
            da diferença da tarifa originalmente paga e a nova tarifa, conforme
            a disponibilidade tarifária no momento de realização da troca, sendo
            obrigatório o pagamento complementar dessa diferença.
          </p>

          <h5
            className="text-center font-wl-600"
            style={{
              padding: "16px 16px 8px 16px",
              margin: 0,
              borderBottom: "1px solid #eee",
              flexShrink: 0,
            }}
          >
            21. DISPOSIÇÕES GERAIS
          </h5>
          <p className="text-sm mb-3">
            <strong>21.</strong> Qualquer necessidade de pagamento complementar
            (alterações na reserva original, serviços extras, entre outros)
            somente poderá ser realizado utilizando o cartão de crédito como
            meio de pagamento, no qual a finalização da operação depende da
            autorização e confirmação do pagamento pela administradora do
            cartão.
          </p>
          <p className="text-sm mb-3">
            <strong>22.</strong> O transporte aéreo é de responsabilidade da
            companhia aérea, conforme as condições por esta estabelecida e
            determinada, assim como o cumprimento de data e horário dos voos e o
            transporte de bagagem. O bilhete de passagem constitui o único
            compromisso entre a companhia aérea e o Cliente.
          </p>
          <p className="text-sm mb-3">
            <strong>23.</strong> É de única e exclusiva responsabilidade das
            companhias aéreas e/ou de suas controladoras e/ou sucessoras, hotéis
            e demais fornecedores a qualidade e a garantia dos produtos e/ou
            serviços oferecidos.
          </p>
          <p className="text-sm mb-3">
            <strong>24.</strong> Caso haja acompanhante(s), o Cliente assume a
            responsabilidade pelo cumprimento das condições contidas neste Termo
            e Condições Gerais de Uso, que deverá ser observado também por esta
            pessoa.
          </p>
          <p className="text-sm mb-3">
            <strong>25.</strong> O Cliente está ciente de que deverá reclamar,
            em até 30 (trinta) dias, por qualquer problema ocorrido na compra
            e/ou utilização dos pacotes turísticos, sob pena de não mais poder
            fazê-lo, conforme determina o artigo 26, inciso I, do Código de
            Defesa do Consumidor.
          </p>
          <p className="text-sm mb-3">
            <strong>26.</strong> Em caso de dúvidas, solicitamos ao Cliente que
            entre em contato a Central de Atendimento do Programa ou verifique
            as condições diretamente com a companhia aérea ou fornecedor
            responsável.
          </p>
          <p className="text-sm mb-3">
            <strong>27.</strong> O cliente declara estar ciente e plenamente de
            acordo com as condições gerais e específicas dos serviços que está
            solicitando, não tendo dúvida, reserva ou ressalva a este respeito.
          </p>
        </div>
        <div
          className="text-center"
          style={{
            padding: "16px",
            borderTop: "1px solid #eee",
            flexShrink: 0,
          }}
        >
          <Button
            type="button"
            className="btn-default-wl text-xxs font-wl-700"
            onClick={handleModal}
            style={{ minWidth: "150px" }}
          >
            FECHAR
          </Button>
        </div>
      </div>
    </ModalApp>
  );
};

AereoTermsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleModal: PropTypes.func.isRequired,
};

export default AereoTermsModal;
